import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, timer } from 'rxjs';
import { map, catchError, retry } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie';

import { NotificationsService } from 'angular2-notifications';
import { Angulartics2 } from 'angulartics2';

import {
    timeout,
    retryWhen,
    take,
    concat,
    share,
    delayWhen
} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  constructor(private http: HttpClient, private cookieService: CookieService,private notify: NotificationsService, private angulartics2: Angulartics2 ) { }
  static readonly apiPath:string = "/api";

  public registerEmail(email: string, password: string, newsletter: boolean) {
      return this.post('/auth/register/email', {'email': email, 'password': password});
  }

  public loginEmail(email: string, password: string) {
    return this.post('/auth/login/email', {'email': email, 'password': password});
  }

  public activateEmail(code: string) {
      return this.post('/auth/activate', {'activationCode': code});
  }

  public lostPassword(email: string) {
      return this.post('/auth/lostPassword', {'email': email});
  }

  public resetPassword(resetCode: string, password: string) {
      return this.post('/auth/resetPassword', {'code': resetCode, 'password': password});
  }

  public isEmailRegistered(email: string) {
      return this.post('/auth/register/isEmailRegistered', {'email': email});
  }

  public isEmailSubscribed(email: string) {
      return this.post('/newsletter/isEmailSubscribed', {'email': email});
  }

  public subscribeNewsletter(email: string, newsletterId: string) {
      var adCode = this.cookieService.get('adcode');
      return this.post('/newsletter/subscribe', {'email': email, 'newsletterId': newsletterId, 'adCode': adCode});
  }

  public activateNewsletter(code: string) {
      return this.post('/newsletter/activate', {'code': code});
  }


  private post(url: string, data: any) {
      const httpOptions = {
          headers: new HttpHeaders({'Content-Type': 'application/json'})
      };
      return this.http.post(ApiService.apiPath+url, data, httpOptions).pipe(
          timeout(3000),
          catchError(this.handleError)
      );
  }

  getUsers() {
    return this.http.get('/api/account').pipe(
        catchError(this.handleError)
    );
  }

  handleError = (error) => {
      if (error.name && error.name == "TimeoutError") {
          this.notify.error('Request timeout! Please try again!');
          this.angulartics2.eventTrack.next({action: 'error_timeout', properties: {category: 'error'}});
      } else if (error.error instanceof ErrorEvent) {
          // A client-side or network error occurred. Handle it accordingly.
          console.error('An error occurred:', error.error.message);
          this.notify.error('Error: '+error.error.message);
          this.angulartics2.eventTrack.next({action: 'error', properties: {category: 'error', label: error.error.message}});
      } else {
          var object = error.error;
          if(object.statusCode && object.message) {
              this.notify.error("Error "+object.statusCode+": "+object.message);
              this.angulartics2.eventTrack.next({action: 'error_'+object.statusCode, properties: {category: 'error', label: object.message}});
          } else {
              this.notify.error("Error "+error.status+": "+error.error);
              this.angulartics2.eventTrack.next({action: 'error_'+error.status, properties: {category: 'error', label: error.error.message}});
          }
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.error(
              `Backend returned code ${error.status}, ` +
              `body was: ${error.error}`);
      }
      // return an observable with a user-facing error message
      return throwError('Something bad happened; please try again later.');
  };
}
